import styled, { css } from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/lexusTheme";
import type { BannerVariantsType } from "./Banner";

// STYLES
const warranty = css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: var(--spacing-3);
    padding: var(--spacing-3);
    background-color: var(--color-white);

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        align-self: stretch;
        column-gap: var(--spacing-4);
        row-gap: 0;
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        padding: 0;
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        padding: var(--spacing-3);
    }

    @supports not (padding-inline: 0) {
        & > *:not(:nth-last-child(1)) {
            margin-right: var(--spacing-4);
        }
    }
`;

const customerSupport = css`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-2);
    padding: var(--spacing-3);
    background-color: var(--color-white);
    box-shadow:
        0px 15px 80px 0px rgba(0, 0, 0, 0.04),
        0px 4.522px 24.118px 0px rgba(0, 0, 0, 0.05),
        0px 1.878px 10.017px 0px rgba(0, 0, 0, 0.03),
        0px 0.679px 3.623px 0px rgba(0, 0, 0, 0.02);

    @supports not (row-gap: 0) {
        & > *:not(:nth-last-child(1)) {
            margin-bottom: var(--spacing-3) !important;
        }
    }
`;

// COMPONENTS
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-3);

    @supports not (padding-inline: 0) {
        & > *:not(:nth-last-child(1)) {
            margin-bottom: var(--spacing-3);
        }
    }
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-3);
    padding: var(--spacing-3);
    background-color: var(--color-cloud);

    & > div {
        width: 100%;
        &:nth-child(1) {
            display: flex;
            flex-direction: column;
            row-gap: calc(var(--spacing-3) / 2);
        }
    }

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        column-gap: var(--spacing-3);
        row-gap: 0;

        & > div {
            flex-grow: 1;

            &:nth-child(1) {
                align-items: flex-start;
                max-width: 50%;
            }

            &:nth-child(2) {
                align-self: center;
            }
        }
    }

    @supports not (padding-inline: 0) {
        & > div {
            &:not(:nth-last-child(1)) {
                margin-right: var(--spacing-3);
            }
            &:nth-child(1) {
                & > *:not(:nth-last-child(1)) {
                    margin-bottom: calc(var(--spacing-3) / 2) !important;
                }
            }
        }
    }
`;

export const BannerVariants = {
    warranty,
    "customer-support": customerSupport,
};

const BannerVariant = styled.div<{ variant: BannerVariantsType }>`
    ${({ variant }) =>
        variant &&
        css`
            ${BannerVariants[variant]};
        `};
`;

export default BannerVariant;
